export default function photos() {

  $('.page-photos .photo-list .item').magnificPopup({
    delegate: 'a',
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    verticalFit: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0,1],
      arrowMarkup: '<button title="%title%" type="button" class="btn-%dir% fal fa-chevron-%dir%"></button>', 
      tCounter: '<span>%curr%</span> of %total%'
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: function(item) {
        return item.el.attr('title');
      }
    }
  });
}